import React from 'react';
import { connect } from 'react-redux';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { withNavigationFocus } from 'react-navigation';
import { Auth } from 'aws-amplify';

import withAuth from 'common/hoc/withAuth';

import { DRNInputField, DRNButton, DRNText } from '@traveloka/district-ui';

import login from 'modules/general/shared/action/login';

import TOSLogo from 'common/res/svg/TosLogo';
import R from 'common/res/R';
import PasswordInput from 'common/components/PasswordInput/PasswordInput';
import {
  withPageStateProvider,
  pageState,
} from 'common/libs/PageState/pageState';

const mapStateToProps = state => ({
  authState: state.general.auth,
});

const mapDispatchToProps = dispatch => ({
  login: authResult => dispatch(login(authResult)),
});

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
);

@connectToRedux
@withAuth
@withNavigationFocus
@withPageStateProvider()
@pageState()
export default class LoginScreen extends React.Component {
  state = {
    email: '',
    errorEmail: '',
    password: '',
    isLoading: false,
  };

  checkLogin = () => {
    const { auth } = this.props;

    if (auth.isAuthenticated) {
      this.navigateToHome();
    }
  };

  componentDidMount() {
    this.checkLogin();
  }

  navigateToHome = () => {
    const { navigation } = this.props;
    navigation.push('Home');
  };

  @pageState({ error: 'snackbar.error' })
  handleSignIn = async () => {
    const { auth } = this.props;
    const { email, password } = this.state;

    try {
      this.setState({ isLoading: true });

      // TODO: handle federated login using google

      const response = await Auth.signIn({ username: email, password });

      auth.applyUser(response.signInUserSession);

      this.navigateToHome();
    } catch (error) {
      throw error;
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleEmailChange = event => {
    const email = event.target.value || '';
    this.setState({
      email,
    });

    this.validateEmail(email);
  };

  handleForgotPassword = () => {
    const { navigation } = this.props;
    navigation.push('ForgotPassword');
  };

  validateEmail = email => {
    if (!email) {
      return this.setState({ errorEmail: 'Email is required' });
    }

    const emailRegex = new RegExp(
      '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
    );

    if (!emailRegex.test(email)) {
      return this.setState({ errorEmail: 'Email is invalid' });
    }

    return this.setState({ errorEmail: '' });
  };

  static navigationOptions = {
    header: null,
  };

  render() {
    const { email, password, errorEmail, isLoading } = this.state;
    const isButtonDisabled = errorEmail || !password | isLoading;

    return (
      <View style={styles.page}>
        <View style={styles.container}>
          <View style={styles.logoContainer}>
            <TOSLogo />
          </View>
          <View style={styles.formContainer}>
            <DRNInputField
              label="E-mail"
              value={email}
              error={errorEmail}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={this.handleEmailChange}
            />

            <PasswordInput
              label="Password"
              value={password}
              variant={DRNInputField.VARIANT_STANDARD}
              onChange={event =>
                this.setState({ password: event.target.value })
              }
            />
            <TouchableOpacity
              style={{ marginTop: 8 }}
              onPress={this.handleForgotPassword}
            >
              <DRNText variant="ui-tiny">Forgot Password?</DRNText>
            </TouchableOpacity>

            <DRNButton
              size="medium"
              onPress={this.handleSignIn}
              text="Sign In"
              variant="main-cta"
              style={{ marginTop: 16 }}
              isLoading={isLoading}
              disabled={isButtonDisabled}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  page: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  container: {
    width: 400,
    backgroundColor: 'white',
  },
  logoContainer: {
    padding: 16,
    backgroundColor: R.color.brand,
    justifyContent: 'center',
  },
  formContainer: {
    padding: 16,
  },
});
